import { ALLOWED_QUERY_PARAMS, CHANNEL_TYPES } from '../constants/common';
import { bidgelyStorage } from './storageHelper';
import { getCamelCaseString } from './helper';

const queryString = require('query-string');

export function parseQueryParams(queryParamString){
    return (queryString.parse(queryParamString));
}

export function setRefValues(props) {
  let refVal = {
    referrer : CHANNEL_TYPES.WEB,
    ref_type : props.lastLocation.pathname
  };
  if(props.location.pathname === props.lastLocation.pathname){
    if(props.queryParams.deliveryMode) {
      refVal = {
        referrer : props.queryParams.deliveryMode,
        ref_type: props.queryParams.eventType
      }
    }
  }
  return refVal;
}

export function setAndPrepareStateParam(location, persistParams) {
  let queryParams = parseQueryParams(location.search);
  let parsedData = {};
  let key_;

    Object.keys(queryParams).map( (param) => {
    if(ALLOWED_QUERY_PARAMS.indexOf(param) >= 0){
         if(persistParams){
          bidgelyStorage.setItem(param, queryParams[param]);
         }
       key_ = getCamelCaseString(param);
       parsedData[key_] = queryParams[param];
    }
  });
    return parsedData;
}

export function getCleanURL(location, updatedParams) {
  let queryParams = parseQueryParams(location.search);
  let params = [];
  let excludeParams = ['user-hash'];

  if(updatedParams){
    updatedParams.map(param =>{
      excludeParams.push(param.name);
      params.push(`${param.name}=${param.value}`);
    });
  }

  for (const param in queryParams) {
    if (excludeParams.indexOf(param) === -1) {
      params.push(`${param}=${queryParams[param]}`)
    }
  }

  let queryString = params.join('&');
  queryString = queryString ? `?${queryString}` : '';
  return `${location.pathname}${queryString}`;
}
